import { FC } from 'react';
import ProPagination, { PaginationProps } from './pagination';

export type IPaginationComponent = FC<PaginationProps>;

const TransPagination = ProPagination as IPaginationComponent;

export default TransPagination;
